type GenericObjectWithKeys = { [key: string]: any };

export const orderByKey = <T extends GenericObjectWithKeys>(key: string, arr: T[]): T[] =>
  arr.sort((a: GenericObjectWithKeys, b: GenericObjectWithKeys) => (a[key] < b[key] ? -1 : 1));
